import { render, staticRenderFns } from "./OptionsForm.vue?vue&type=template&id=81bbdf7e"
import script from "./OptionsForm.vue?vue&type=script&lang=js"
export * from "./OptionsForm.vue?vue&type=script&lang=js"
import style0 from "./OptionsForm.vue?vue&type=style&index=0&id=81bbdf7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports